<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
  <div class="col-md-12 mx-auto">
    <h3>Asignar empleados a cabina</h3>
  </div>
  <hr />

  <div class="d-grip gap-1 d-md-flex justify-content-md-end mb-5">
    <a [routerLink]="['/cabins/list']" class="btn btn-outline-success">
      <i class="bi bi-arrow-left-circle"></i>
      Regresar a lista de cabinas
    </a>
  </div>

  <div class="col-sm-12 col-md-12 col-lg-12 mx-auto">
    <div *ngIf="isSaved" class="alert alert-success" role="alert">
      {{ message }}
    </div>
    <form
      [formGroup]="cabinAssignForm"
      (ngSubmit)="updateUsersCabins()"
      novalidate
    >
      <div class="accordion" id="cabins_accordion">
        <div class="accordion-item">
          <h2 class="accordion-header" id="cabin-information">
            <button
              class="accordion-button color-header-collapse"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              disabled
            >
              <span class="color-text">
                Actualizaci&oacute;n de usuarios por cabina
              </span>
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <input type="hidden" name="cabinId" formControlName="cabinId" />
              <div class="row">
                <div class="row">
                  <div class="col-md-5 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="employeeOne"
                      name="employeeOne"
                      formControlName="employeeOne"
                    >
                      <option selected value="" class="">
                        Selecciona colaborador
                      </option>
                      <option
                        *ngFor="let employee of employees"
                        value="{{ employee.id }}"
                      >
                        {{ employee.first_name }} {{ employee.last_name }}
                      </option>
                    </select>
                    <label class="ms-2" for="employeeOne">
                      Selecciona una sucursal
                    </label>
                  </div>

                  <div class="col-md-5 mb-3 form-floating">
                    <input
                      type="hidden"
                      name="dayOne"
                      id="dayOne"
                      formControlName="dayOne"
                    />
                    <input
                      type="text"
                      disabled
                      value="{{ days[0].name }}"
                      class="form-control"
                    />
                    <label class="ms-2">Selecciona un dia</label>
                  </div>

                  <div class="col-md-2 mb-3 mt-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="restOne"
                      id="restOne"
                    />
                    <label class="form-check-label ms-2" for="restOne">
                      D&iacute;a de descanso
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourStartOne"
                      name="hourStartOne"
                      formControlName="hourStartOne"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de entrada
                      </option>
                      <option
                        *ngFor="let number of [8, 9, 10, 11, 12]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourStartOne" class="ms-2"
                      >Hora de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteStartOne"
                      name="minuteStartOne"
                      formControlName="minuteStartOne"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de entrada
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteStartOne" class="ms-2">
                      Minutos de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourEndOne"
                      name="hourEndOne"
                      formControlName="hourEndOne"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de cierre
                      </option>
                      <option
                        *ngFor="let number of [19, 20, 21, 22]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourEndOne" class="ms-2">
                      Hora de Salida
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteEndOne"
                      name="minuteEndOne"
                      formControlName="minuteEndOne"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de salida
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteEndOne" class="ms-2">
                      Minutos de salida
                    </label>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="row">
                  <div class="col-md-5 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="employeeTwo"
                      name="employeeTwo"
                      formControlName="employeeTwo"
                    >
                      <option selected value="" class="">
                        Selecciona colaborador
                      </option>
                      <option
                        *ngFor="let employee of employees"
                        value="{{ employee.id }}"
                      >
                        {{ employee.first_name }} {{ employee.last_name }}
                      </option>
                    </select>
                    <label class="ms-2" for="employeeTwo">
                      Selecciona una sucursal
                    </label>
                  </div>
                  <div class="col-md-5 mb-3 form-floating">
                    <input
                      type="hidden"
                      name="dayTwo"
                      id="dayTwo"
                      formControlName="dayTwo"
                    />
                    <input
                      type="text"
                      disabled
                      value="{{ days[1].name }}"
                      class="form-control"
                    />
                    <label class="ms-2">Selecciona un dia</label>
                  </div>
                  <div class="col-md-2 mb-3 mt-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="restTwo"
                      id="restTwo"
                    />
                    <label class="form-check-label ms-2" for="restTwo">
                      D&iacute;a de descanso
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourStartTwo"
                      name="hourStartTwo"
                      formControlName="hourStartTwo"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de entrada
                      </option>
                      <option
                        *ngFor="let number of [8, 9, 10, 11, 12]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourStartTwo" class="ms-2"
                      >Hora de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteStartTwo"
                      name="minuteStartTwo"
                      formControlName="minuteStartTwo"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de entrada
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteStartTwo" class="ms-2">
                      Minutos de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourEndTwo"
                      name="hourEndTwo"
                      formControlName="hourEndTwo"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de cierre
                      </option>
                      <option
                        *ngFor="let number of [19, 20, 21, 22]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourEndTwo" class="ms-2">
                      Hora de Salida
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteEndTwo"
                      name="minuteEndTwo"
                      formControlName="minuteEndTwo"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de salida
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteEndTwo" class="ms-2">
                      Minutos de salida
                    </label>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="row">
                  <div class="col-md-5 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="employeeThree"
                      name="employeeThree"
                      formControlName="employeeThree"
                    >
                      <option selected value="" class="">
                        Selecciona colaborador
                      </option>
                      <option
                        *ngFor="let employee of employees"
                        value="{{ employee.id }}"
                      >
                        {{ employee.first_name }} {{ employee.last_name }}
                      </option>
                    </select>
                    <label class="ms-2" for="employeeThree">
                      Selecciona una sucursal
                    </label>
                  </div>
                  <div class="col-md-5 mb-3 form-floating">
                    <input
                      type="hidden"
                      name="dayThree"
                      id="dayThree"
                      formControlName="dayThree"
                    />
                    <input
                      type="text"
                      disabled
                      value="{{ days[2].name }}"
                      class="form-control"
                    />
                    <label class="ms-2">Selecciona un dia</label>
                  </div>
                  <div class="col-md-2 mb-3 mt-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="restThree"
                      id="restThree"
                    />
                    <label class="form-check-label ms-2" for="restThree">
                      D&iacute;a de descanso
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourStartThree"
                      name="hourStartThree"
                      formControlName="hourStartThree"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de entrada
                      </option>
                      <option
                        *ngFor="let number of [8, 9, 10, 11, 12]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourStartThree" class="ms-2"
                      >Hora de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteStartThree"
                      name="minuteStartThree"
                      formControlName="minuteStartThree"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de entrada
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteStartThree" class="ms-2">
                      Minutos de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourEndThree"
                      name="hourEndThree"
                      formControlName="hourEndThree"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de cierre
                      </option>
                      <option
                        *ngFor="let number of [19, 20, 21, 22]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourEndThree" class="ms-2">
                      Hora de Salida
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteEndThree"
                      name="minuteEndThree"
                      formControlName="minuteEndThree"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de salida
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteEndThree" class="ms-2">
                      Minutos de salida
                    </label>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="row">
                  <div class="col-md-5 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="employeeFour"
                      name="employeeFour"
                      formControlName="employeeFour"
                    >
                      <option selected value="" class="">
                        Selecciona colaborador
                      </option>
                      <option
                        *ngFor="let employee of employees"
                        value="{{ employee.id }}"
                      >
                        {{ employee.first_name }} {{ employee.last_name }}
                      </option>
                    </select>
                    <label class="ms-2" for="employeeFour">
                      Selecciona una sucursal
                    </label>
                  </div>
                  <div class="col-md-5 mb-3 form-floating">
                    <input
                      type="hidden"
                      name="dayFour"
                      id="dayFour"
                      formControlName="dayFour"
                    />
                    <input
                      type="text"
                      disabled
                      value="{{ days[3].name }}"
                      class="form-control"
                    />
                    <label class="ms-2">Selecciona un dia</label>
                  </div>
                  <div class="col-md-2 mb-3 mt-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="restFour"
                      id="restFour"
                    />
                    <label class="form-check-label ms-2" for="restFour">
                      D&iacute;a de descanso
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourStartFour"
                      name="hourStartFour"
                      formControlName="hourStartFour"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de entrada
                      </option>
                      <option
                        *ngFor="let number of [8, 9, 10, 11, 12]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourStartFour" class="ms-2"
                      >Hora de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteStartFour"
                      name="minuteStartFour"
                      formControlName="minuteStartFour"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de entrada
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteStartFour" class="ms-2">
                      Minutos de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourEndFour"
                      name="hourEndFour"
                      formControlName="hourEndFour"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de cierre
                      </option>
                      <option
                        *ngFor="let number of [19, 20, 21, 22]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourEndFour" class="ms-2">
                      Hora de Salida
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteEndFour"
                      name="minuteEndFour"
                      formControlName="minuteEndFour"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de salida
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteEndFour" class="ms-2">
                      Minutos de salida
                    </label>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="row">
                  <div class="col-md-5 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="employeeFive"
                      name="employeeFive"
                      formControlName="employeeFive"
                    >
                      <option selected value="" class="">
                        Selecciona colaborador
                      </option>
                      <option
                        *ngFor="let employee of employees"
                        value="{{ employee.id }}"
                      >
                        {{ employee.first_name }} {{ employee.last_name }}
                      </option>
                    </select>
                    <label class="ms-2" for="employeeFive">
                      Selecciona una sucursal
                    </label>
                  </div>
                  <div class="col-md-5 mb-3 form-floating">
                    <input
                      type="hidden"
                      name="dayFive"
                      id="dayFive"
                      formControlName="dayFive"
                    />
                    <input
                      type="text"
                      disabled
                      value="{{ days[4].name }}"
                      class="form-control"
                    />
                    <label class="ms-2">Selecciona un dia</label>
                  </div>
                  <div class="col-md-2 mb-3 mt-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="restFive"
                      id="restFive"
                    />
                    <label class="form-check-label ms-2" for="restFive">
                      D&iacute;a de descanso
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourStartFive"
                      name="hourStartFive"
                      formControlName="hourStartFive"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de entrada
                      </option>
                      <option
                        *ngFor="let number of [8, 9, 10, 11, 12]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourStartFive" class="ms-2"
                      >Hora de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteStartFive"
                      name="minuteStartFive"
                      formControlName="minuteStartFive"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de entrada
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteStartFive" class="ms-2">
                      Minutos de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourEndFive"
                      name="hourEndFive"
                      formControlName="hourEndFive"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de cierre
                      </option>
                      <option
                        *ngFor="let number of [19, 20, 21, 22]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourEndFive" class="ms-2">
                      Hora de Salida
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteEndFive"
                      name="minuteEndFive"
                      formControlName="minuteEndFive"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de salida
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteEndFive" class="ms-2">
                      Minutos de salida
                    </label>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="row">
                  <div class="col-md-5 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="employeeSix"
                      name="employeeSix"
                      formControlName="employeeSix"
                    >
                      <option selected value="" class="">
                        Selecciona colaborador
                      </option>
                      <option
                        *ngFor="let employee of employees"
                        value="{{ employee.id }}"
                      >
                        {{ employee.first_name }} {{ employee.last_name }}
                      </option>
                    </select>
                    <label class="ms-2" for="employeeSix">
                      Selecciona una sucursal
                    </label>
                  </div>
                  <div class="col-md-5 mb-3 form-floating">
                    <input
                      type="hidden"
                      name="daySix"
                      id="daySix"
                      formControlName="daySix"
                    />
                    <input
                      type="text"
                      disabled
                      value="{{ days[5].name }}"
                      class="form-control"
                    />
                    <label class="ms-2">Selecciona un dia</label>
                  </div>
                  <div class="col-md-2 mb-3 mt-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="restSix"
                      id="restSix"
                    />
                    <label class="form-check-label ms-2" for="restSix">
                      D&iacute;a de descanso
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourStartSix"
                      name="hourStartSix"
                      formControlName="hourStartSix"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de entrada
                      </option>
                      <option
                        *ngFor="let number of [8, 9, 10, 11, 12]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourStartSix" class="ms-2"
                      >Hora de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteStartSix"
                      name="minuteStartSix"
                      formControlName="minuteStartSix"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de entrada
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteStartSix" class="ms-2">
                      Minutos de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourEndSix"
                      name="hourEndSix"
                      formControlName="hourEndSix"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de cierre
                      </option>
                      <option
                        *ngFor="let number of [19, 20, 21, 22]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourEndSix" class="ms-2">
                      Hora de Salida
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteEndSix"
                      name="minuteEndSix"
                      formControlName="minuteEndSix"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de salida
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteEndSix" class="ms-2">
                      Minutos de salida
                    </label>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="row">
                  <div class="col-md-5 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="employeeSeven"
                      name="employeeSeven"
                      formControlName="employeeSeven"
                    >
                      <option selected value="" class="">
                        Selecciona colaborador
                      </option>
                      <option
                        *ngFor="let employee of employees"
                        value="{{ employee.id }}"
                      >
                        {{ employee.first_name }} {{ employee.last_name }}
                      </option>
                    </select>
                    <label class="ms-2" for="employeeSeven">
                      Selecciona una sucursal
                    </label>
                  </div>
                  <div class="col-md-5 mb-3 form-floating">
                    <input
                      type="hidden"
                      name="daySeven"
                      id="daySeven"
                      formControlName="daySeven"
                    />
                    <input
                      type="text"
                      disabled
                      value="{{ days[6].name }}"
                      class="form-control"
                    />
                    <label class="ms-2">Selecciona un dia</label>
                  </div>
                  <div class="col-md-2 mb-3 mt-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControlName="restSeven"
                      id="restSeven"
                    />
                    <label class="form-check-label ms-2" for="restSeven">
                      D&iacute;a de descanso
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourStartSeven"
                      name="hourStartSeven"
                      formControlName="hourStartSeven"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de entrada
                      </option>
                      <option
                        *ngFor="let number of [8, 9, 10, 11, 12]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourStartSeven" class="ms-2"
                      >Hora de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteStartSeven"
                      name="minuteStartSeven"
                      formControlName="minuteStartSeven"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de entrada
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteStartSeven" class="ms-2">
                      Minutos de entrada
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="hourEndSeven"
                      name="hourEndSeven"
                      formControlName="hourEndSeven"
                    >
                      <option selected value="" class="">
                        Selecciona la hora de cierre
                      </option>
                      <option
                        *ngFor="let number of [19, 20, 21, 22]"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="hourEndSeven" class="ms-2">
                      Hora de Salida
                    </label>
                  </div>

                  <div class="col-md-3 mb-3 form-floating">
                    <select
                      class="form-select"
                      aria-label="Floating label select"
                      id="minuteEndSeven"
                      name="minuteEndSeven"
                      formControlName="minuteEndSeven"
                    >
                      <option selected value="" class="">
                        Selecciona los minutos de salida
                      </option>
                      <option
                        *ngFor="let number of arrayMinutes"
                        value="{{ number }}"
                      >
                        {{ number }}
                      </option>
                    </select>
                    <label for="minuteEndSeven" class="ms-2">
                      Minutos de salida
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-3 mt-2 d-grip gap-2 d-md-flex justify-content-md-end">
        <button type="submit" class="btn btn-success">
          <i class="bi bi-plus-circle"></i>
          Actualizar
        </button>
      </div>
    </form>
  </div>
</div>
